module.exports = __webpack_public_path__ + "static/media/addNew.ba297cb0.svg";